import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroDashboardImg from '../../../assets/landing/hero-dashboard.png';
import HeroDashboardImg2 from '../../../assets/landing/hero-dashboard2.png';
import HeroDashboardImg3 from '../../../assets/landing/hero-dashboard3.png';
import '../LandingPage.css';

const HeroSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        HeroDashboardImg,
        HeroDashboardImg2,
        HeroDashboardImg3
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slides.length]);

    const scrollToFeatures = () => {
        const features = document.querySelector('.lp-workflow');
        if (features) features.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="lp-section lp-hero">
            <div className="lp-hero-content fade-in-section">
                <h1 className="lp-title">
                    The Operating System <br />
                    <span className="text-gradient">For Your Stories.</span>
                </h1>
                <h2 className="lp-subtitle">
                    Generate full-length HD movies with perfect character consistency from simple ideas. <br />
                    Alekhine AI unites scriptwriting, casting, directing, and production in one fluid workspace.
                </h2>
                <div className="lp-cta-group">
                    <Link to="/home">
                        <button className="lp-btn lp-btn-primary">Start Creating</button>
                    </Link>
                    <a href="https://www.youtube.com/channel/UCPBRJB3mSG5I6g3nsNo8DOg" target="_blank" rel="noopener noreferrer">
                        <button className="lp-btn lp-btn-secondary">Learn More</button>
                    </a>
                </div>
            </div>

            <div className="lp-hero-visual fade-in-section">
                <div className="lp-app-frame">
                    <div className="lp-app-frame-glow"></div>

                    {/* Slideshow Images */}
                    {slides.map((src, index) => (
                        <img
                            key={index}
                            src={src}
                            alt={`AlekhineAI Interface ` + (index + 1)}
                            className={`lp-dashboard-img ${index === currentSlide ? 'active' : ''}`}
                        />
                    ))}

                    {/* Slide Indicators */}
                    <div className="lp-slide-indicators">
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                className={`lp-slide-dot ${index === currentSlide ? 'active' : ''}`}
                                onClick={() => setCurrentSlide(index)}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="lp-scroll-indicator" onClick={scrollToFeatures}>
                ↓
            </div>
        </section>
    );
};

export default HeroSection;
